import {Dropdown, ProposalStatus} from '@emma-labs/shared/typescript';

const PROPOSALS_STATUS_OPTIONS_FR: Dropdown<ProposalStatus>[] = [
  {name: 'En cours', value: ProposalStatus.ONGOING},
  {name: 'Signature', value: ProposalStatus.PENDING_CHECKOUT},
  {name: 'Tarification', value: ProposalStatus.PENDING_UNDERWRITING},
  {name: `En attente d'un partenaire externe`, value: ProposalStatus.PENDING_EXTERNAL_ACTION},
  {name: 'Questionnaires supplémentaires', value: ProposalStatus.PENDING_EXTRA_QUESTIONNAIRES},
  {name: 'Décision', value: ProposalStatus.PENDING_MODIFICATION_DECISION},
  {name: 'Approuvée', value: ProposalStatus.APPROVED},
  {name: 'Refusée', value: ProposalStatus.REFUSED},
  {name: 'Abandonée', value: ProposalStatus.ABANDONED},
];

const PROPOSALS_STATUS_OPTIONS_EN: Dropdown<ProposalStatus>[] = [
  {name: 'Ongoing', value: ProposalStatus.ONGOING},
  {
    name: 'Signature',
    value: ProposalStatus.PENDING_CHECKOUT,
  },
  {name: 'Underwriting', value: ProposalStatus.PENDING_UNDERWRITING},
  {name: 'Pending external partner', value: ProposalStatus.PENDING_EXTERNAL_ACTION},
  {name: 'Additional Questionnaires', value: ProposalStatus.PENDING_EXTRA_QUESTIONNAIRES},
  {name: 'Decision', value: ProposalStatus.PENDING_MODIFICATION_DECISION},
  {name: 'Approved', value: ProposalStatus.APPROVED},
  {name: 'Refused', value: ProposalStatus.REFUSED},
  {name: 'Abandoned', value: ProposalStatus.ABANDONED},
];

export const PROPOSALS_STATUS_OPTIONS = {
  en: PROPOSALS_STATUS_OPTIONS_EN,
  fr: PROPOSALS_STATUS_OPTIONS_FR,
};
